// extracted by mini-css-extract-plugin
export default {"main-container":"style_main-container__7W+Qk","main-content":"style_main-content__chMzx"};